import { FILTER_LABEL_MAP } from "modules/category/constants/filter-constants";
import { useTranslation } from "next-i18next";
import styles from "./product-filter/product-filter.module.scss";

function ProductGradeFilter(props) {
  const { filterKey } = props;
  const { t } = useTranslation("category");

  return (
    <>
      <i className={`fa fa-lightbulb-o m-r-10 ${styles.product_grade_icon}`} />
      {t(FILTER_LABEL_MAP[filterKey])}
    </>
  );
}

export default ProductGradeFilter;
